import type { TechniqueEntry } from '../schema';

// review: deliberately no therapeutic frame (the doc's heading note).
export const practicalPlanning: TechniqueEntry = {
  key: 'practical_planning',
  version: '0.1',
  name: 'Practical planning',
  pillar: 'Practical',
  serves:
    "Building a concrete plan the member believes in for one specific situation: the what-do-I-actually-do-at-seven-o'clock question is logistics, and forcing a therapeutic frame onto it makes it worse.",
  method: [
    "Start from their specifics: the situation, who's there, what worked last time, what fell through.",
    'Shape it together: the member supplies the moves, Sona supplies structure and recall of what they have said works for them.',
    'Make it concrete to the hour and the trigger point: what they will actually do at the exact moment the pressure arrives, the moment named specifically.',
    'Anything Sona proposes is an offer to react to, not a prescription.',
    'Close with the member able to say the plan in their own words.',
  ],
  never: [
    'Do not turn the plan into a commitment test.',
    'Do not supply their motivation or prescribe the plan.',
    'No therapeutic reframing of a logistics problem.',
  ],
  requiresFirst: [
    {
      kind: 'conversation',
      clause:
        'A specific, named situation (Saturday\'s party, the Sunday evening), not a general wish to "have a plan".',
    },
  ],
  doneWhen:
    'They can say what they will do at the trigger moment, in their own words, and they believe it.',
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source:
    'Base doc payload worked example (planning_practical — Friday-party member), shared/sections/base_objective.md (plan-shaping stance); catalog #17/#18/#41/#42 are authored-practice instances of this move',
};
